import axios from "axios";

const $host = axios.create({
    baseURL: `https://api.aerospace-agro.com/./`
})

export {
    $host
}